import { ActionIcon, Indicator, Tooltip } from '@mantine/core'
import { IconBell } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { getNotificationsSummary } from '../../api/notificationsApi'

const POLL_INTERVAL_MS = 60_000

export function NotificationBell() {
  const [pendingCount, setPendingCount] = useState(0)
  const navigate = useNavigate()

  useEffect(() => {
    let cancelled = false

    async function fetchSummary() {
      try {
        const summary = await getNotificationsSummary()
        if (!cancelled) {
          setPendingCount(summary.pendingRequests)
        }
      } catch {
        // Silently ignore — bell simply shows no badge on error
      }
    }

    fetchSummary()
    const interval = setInterval(fetchSummary, POLL_INTERVAL_MS)

    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [])

  return (
    <Tooltip label={pendingCount > 0 ? `${pendingCount} pending request${pendingCount === 1 ? '' : 's'}` : 'No pending requests'} withArrow position="bottom">
      <Indicator
        disabled={pendingCount === 0}
        label={pendingCount > 99 ? '99+' : String(pendingCount)}
        size={16}
        color="red"
        processing={pendingCount > 0}
      >
        <ActionIcon
          variant="subtle"
          aria-label="Notifications"
          onClick={() => navigate('/pending-users')}
        >
          <IconBell size={20} />
        </ActionIcon>
      </Indicator>
    </Tooltip>
  )
}
